import React from "react";
import BACK_OFFICE_USER_INFO_FORM from "./back-office-user-info-form";
import BsForm from "components/form/BsForm";
import {changeBoUserStatus, fetchBoUser} from "core/actions/admin-actions";
import {connect} from "react-redux";
import BackOfficeUserInfoActions from "./BackOfficeUserInfoActions";
import ConfirmationModel from "components/model/ConfirmationModel";

class BackOfficeUserInfoTab extends React.Component {

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      confirmationWindow: {
        open: false,
        message: ''
      },
      event: () => {
      }
    };
    this.props.fetchBoUser(this.props.match.params.userId);
  }

  closeConfirmationModel() {
    this.setState({
      ...this.state,
      confirmationWindow: {
        ...this.state.confirmationWindow,
        open: false
      }
    });
  }

  onHandleEnable() {
    this.setState({
      ...this.state,
      confirmationWindow: {
        open: true,
        message: 'admin_info.enable_admin_confirmation_message'
      },
      event: this.enableAdmin
    })
  }

  enableAdmin() {
    this.closeConfirmationModel()
    this.props.changeStatus(this.props.match.params.systemId, this.props.match.params.userId, 'ACTIVE')
  }

  onHandleDisable() {
    this.setState({
      ...this.state,
      confirmationWindow: {
        open: true,
        message: 'admin_info.disable_admin_confirmation_message'
      },
      event: this.disableAdmin
    })
  }

  disableAdmin() {
    this.closeConfirmationModel()
    this.props.changeStatus(this.props.match.params.systemId, this.props.match.params.userId, 'DISABLED')
  }

  render() {
    if (this.props.currentAdmin) {
      const formConfig = {
        ...BACK_OFFICE_USER_INFO_FORM,
        title: {
          back: {
            url: '/global/bo-users',
            history: this.props.history,
            location: this.props.location
          },
          actions: <BackOfficeUserInfoActions
            user={this.props.currentAdmin}
            onHandleEnable={this.onHandleEnable.bind(this)}
            onHandleDisable={this.onHandleDisable.bind(this)}/>
        }
      };

      return (
          <div className="bs-form-container">
            <ConfirmationModel
              open={this.state.confirmationWindow.open}
              message={this.state.confirmationWindow.message}
              handleClose={this.closeConfirmationModel.bind(this)}
              handleApply={this.state.event.bind(this)}
            />

            <BsForm
                config={formConfig}
                formData={this.props.currentAdmin}
                disabled={true}/>
          </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admin.currentAdmin
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBoUser: (userId) => {
      dispatch(fetchBoUser(userId));
    },
    changeStatus: (systemId, userId, status) => {
      dispatch(changeBoUserStatus(systemId, userId, status));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeUserInfoTab);
